import type { UserFavoriteMediaRequest } from '@cobliteam/common-types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class UserFavoriteMediaRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public updateUserFavoriteMedia = async ({ mediaId, isFavorite }: UserFavoriteMediaRequest): Promise<UserFavoriteMediaRequest> => {
    const requestData: IRequest = {
      endpoint: `/cameras/media/${mediaId}/favorite`,
      method: HttpMethod.PUT,
      body: JSON.stringify({
        is_favorite: isFavorite,
      }),
    };

    const { data } = await this.requester.request(requestData);

    return data;
  };
}

export default UserFavoriteMediaRequester;
